export const SMALLER_LIST_ITEM_HEIGHT = 24;
export const STANDARD_LIST_ITEM_HEIGHT = 36;
export const HEADING_ITEM_HEIGHT = 44;
